import { useMemo } from "react";

export function useWidgetTablePageSize(height: number, rowHeight = 45, bottomSectionHeight = 50) {
  return useMemo(
    () => Math.max(Math.floor((height - bottomSectionHeight) / rowHeight), 3),
    [bottomSectionHeight, height, rowHeight]
  );
}
